// not-found.tsx — Sprint 116: improved 404 experience with navigation CTA
import { useLocation } from 'wouter';

export default function NotFound() {
  const [, navigate] = useLocation();
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#050508',
      fontFamily: 'monospace',
      padding: '24px',
    }}>
      <div style={{ textAlign: 'center', maxWidth: 400 }}>
        {/* Large 404 */}
        <div style={{
          fontSize: 96,
          fontWeight: 800,
          letterSpacing: '-0.04em',
          color: 'rgba(59,130,246,0.9)',
          lineHeight: 1,
          marginBottom: 16,
          textShadow: '0 0 40px rgba(59,130,246,0.4)',
        }}>404</div>

        {/* Label */}
        <div style={{
          fontSize: 10,
          letterSpacing: '0.35em',
          color: 'rgba(255,255,255,0.22)',
          textTransform: 'uppercase',
          marginBottom: 12,
        }}>
          WORKROAMER™ — SIGNAL LOST
        </div>

        {/* Message */}
        <p style={{
          fontSize: 13,
          color: 'rgba(255,255,255,0.5)',
          letterSpacing: '0.05em',
          marginBottom: 32,
          lineHeight: 1.6,
        }}>
          This sector isn't on the map.<br />
          Let's get you back on course.
        </p>

        {/* Return CTA */}
        <button
          onClick={() => navigate('/home')}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 10,
            padding: '14px 28px',
            background: 'linear-gradient(90deg, #1a3fcc 0%, #2563eb 50%, #3b82f6 100%)',
            border: 'none',
            borderRadius: 8,
            color: '#fff',
            fontSize: 12,
            fontWeight: 800,
            letterSpacing: '0.18em',
            textTransform: 'uppercase',
            cursor: 'pointer',
            boxShadow: '0 4px 18px rgba(37,99,235,0.45)',
            fontFamily: 'monospace',
          }}
        >
          🛸 Return to Mission Control
        </button>

        {/* Breadcrumb hint */}
        <p style={{
          marginTop: 20,
          fontSize: 10,
          color: 'rgba(255,255,255,0.18)',
          letterSpacing: '0.12em',
        }}>
          or use the sidebar navigation
        </p>
      </div>
    </div>
  );
}
